(() => {
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduce) return;

  const els = [...document.querySelectorAll("[data-parallax-lite]")];
  if (!els.length) return;

  let ticking = false;

  function update() {
    ticking = false;
    const vh = window.innerHeight;

    for (const el of els) {
      const rect = el.getBoundingClientRect();
      // progress through viewport (-1..1)
      const p = ((rect.top + rect.height / 2) - vh / 2) / (vh / 2);
      const amount = parseFloat(el.dataset.parallaxLite || "12"); // px
      const y = Math.max(-amount, Math.min(amount, -p * amount));
      el.style.setProperty("--py", `${y.toFixed(2)}px`);
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll);
  onScroll();
})();
